module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc13-bb83b9943a778cdc21e47404d7ff356d.jpg";